export default function Main({children}){
    return (
      <div> {children}</div>
    )
}